<template>
	<view>
		<uni-nav-bar :fixed="true" statusBar  title="购物车" :color="vuex_fontColor" :backgroundColor="vuex_backgroundColor"></uni-nav-bar>
		<view v-if="goodsList.length>0" class="shop_list_top f_r_c_sb">
		共{{goodsList.length}}个商品
		<view class="f_r_c_c">
			<up-button style="width: 200rpx;margin-right: 32rpx;" v-if="isShowClearStopProd==1" type="primary" :color="vuex_skinColor" @click="fnClearStopProd">清除失效商品</up-button>
			<up-button v-if="isSettlement" type="primary" :color="vuex_skinColor" @click="fnCartSet">编辑</up-button>
			<up-button v-if="!isSettlement" type="primary" :color="vuex_skinColor" @click="fnCartSet">完成</up-button>
		</view>
		</view>
		<noDataImg v-if="goodsList==null||goodsList.length==0" imgUrl="/static/images/newImg003_03.jpg" :isShowBtn="false" width="500rpx" height="500rpx" marginTop="200rpx" content="购物车空空如也 赶紧去商城逛逛吧~"></noDataImg>
		
		<!-- 购物车列表 -->
		<view class="cart-list">
			<view class="item" v-for="(goods, index) in goodsList" :key="index">
				<view class="left"><up-checkbox usedAlone :disabled="goods.isFall == 1?true:false" shape="circle" @change="checkOneGoods(goods)" :active-color="vuex_skinColor" icon-size="16" v-model:checked="goods.checked" ></up-checkbox></view>
				<view class="right">
					<view style="position: absolute;z-index: 9;background: red;width: 160rpx;text-align: center;color: white;">{{goods.fallRemark}}</view>
					<view class="img"><up-image width="160rpx" height="160rpx" :src="util.fnImgRequestPath(goods.imgUrl)" mode=""></up-image></view>
					<view class="info">
						<view class="title">{{ goods.prodName }}</view>
						<view class="sku">{{ goods.label }}</view>
						<view class="operate">
							<view class="price">
								<text>￥</text>
								<text>{{ goods.price }}</text>
								<text style="margin-left: 16rpx;" v-if="membType == 1">￥{{ goods.udValue }}</text>
							</view>
							<view class="num"><up-number-box :asyncChange="true" :name="goods.singleProdId" :disabled="goods.isFall == 1?true:false" v-model="goods.num" @change="fnNumBlur"  @blur="fnNumBlur"></up-number-box></view>
						</view>
					</view>
				</view>
			</view>
		</view>
		<view class="cu-tabbar-height"></view>
		 
		
		<!-- 底部按钮 -->
		<view class="btn f_c_c_c _w100">
			<view class=" f_r_c_sb _w100">
				<view class="check f_r_c_c">
					<up-checkbox usedAlone shape="circle" :active-color="vuex_skinColor" icon-size="16" v-model:checked="checkAllStauts" @change="checkAllGoods"></up-checkbox>
					<text>全选</text>
				</view>
				<view class="right f_r_c_c">
					<view class="price f_r_c_c" style="align-items: baseline !important;">
						<view>合计：</view>
						<view :style="{color:vuex_skinColor}">￥</view>
						<view :style="{color:vuex_skinColor}">{{ totalPrice }}</view>
					</view>
					<up-button v-if="isSettlement" type="primary" :color="vuex_skinColor" @click="goPayResult">立即支付({{ goodsList.filter(item => item.checked).length }})</up-button>
					<up-button v-if="!isSettlement" type="primary" :color="vuex_skinColor" @click="fnDeleteShoppingCart">删除({{ goodsList.filter(item => item.checked).length }})</up-button>
				</view>
			</view>
		</view>
	</view>
</template>

<script setup>
	import {getCurrentInstance, reactive, ref} from "vue";
	import { onLoad, onShow } from '@dcloudio/uni-app'
	import {selectProdInfoBysingleProdIdsApi} from '@/api/prod/prod';
	import * as util from "@/utils/utils";
	import {checkOutMembInfoApi, getMembInfoById2ObjApi} from '@/api/memb/membInfo';
	import {getBaseSystemSetInfoByPlatId} from '@/api/base/baseRuleSet';
	import noDataImg from '@/components/no_data_img.vue';
	// 定义可以触发的事件
	const emit = defineEmits(['fnDealCartNum'])
	// 获取Vue实例上下文
	const {ctx} = getCurrentInstance();
	const goodsList = ref([])
	const isSettlement = ref(true)// 是结算还是删除
	const checkAllStauts = ref(false)// 是否全选
	const totalPrice = ref(0)
	const isShowClearStopProd = ref(0)// 是否显示清除失效商品按钮
	const membType = ref(0)
	/**
	 * 页面的初始数据
	 */
	const data = reactive({
		extInfoUrl:'',
		corpId:'',
		limitChiefGradeId:'',
		limitChiefLevel:'',
		isDontSale:'',
	})
	/**
	 * 页面加载时执行的函数
	 */
	onLoad((options) => {
		console.log("onLoad 我是cart")
		if(uni.getStorageSync('lifeData').vuex_user){
			membType.value = uni.getStorageSync('lifeData').vuex_user.membType
			// 获取购物车商品数据
			const savedCart = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
			console.log("----------savedCart",savedCart)
			if(savedCart && savedCart != undefined && savedCart != null){
				goodsList.value = JSON.parse(savedCart);
			}
			if(goodsList.value != null && goodsList.value.length > 0){
				// 查询购物车商品是否禁用
				fnGetShoppingCartSingleProd()
			}
		}
		// 获取系统设置
		fnGetBaseSystemSetInfoByPlatId();
	})
	/**
	 * 获取系统设置
	 */
	function fnGetBaseSystemSetInfoByPlatId(){
		let param = {
		    platId:1
		};
		console.log("-------------param",param)
		getBaseSystemSetInfoByPlatId(JSON.stringify(param)).then(res => {
		    if(res.retCode == 1){
				data.extInfoUrl = res.obj.extInfoUrl;
				data.corpId = res.obj.corpId;
				data.limitChiefGradeId = res.obj.chiefGradeId;
				data.limitChiefLevel = res.obj.chiefLevel;
				data.isDontSale = res.obj.isDontSale;
			}
		})
	}
	/**
	 * 查询购物车商品是否禁用
	 */
	function fnGetShoppingCartSingleProd(){
		let shoppingCarts = goodsList.value;
		let prodSingleIds = [];
		for(let i=0;i<shoppingCarts.length;i++){
			prodSingleIds.push(shoppingCarts[i].singleProdId)
		}
		let param = {}
		param.platId = 1;
		param.singleProdIds = prodSingleIds;
		param.gradeId = uni.getStorageSync('lifeData').vuex_user.memberGradeId
		selectProdInfoBysingleProdIdsApi(JSON.stringify(param)).then(res => {
		    if(res.retCode == 1){
				shoppingCarts.forEach(oldBo => {
					res.objs.forEach(newBo => {
						if(newBo.singleProdId == oldBo.singleProdId){
							if(newBo.isState == 1){
								oldBo.isFall =1;
								oldBo.fallRemark = "商品已失效"
								isShowClearStopProd.value = 1;
							}
						}
					})
				})
				goodsList.value = shoppingCarts;
			}
		})
	}
	// 变更编辑/完成
	function fnCartSet(){
		let state = isSettlement.value;
		isSettlement.value = !state
	}
	// 选中单个商品
	function checkOneGoods(){
		setTimeout(() => {
			// 判断是否全部选中了
			let flag = true;
			let shoppingCarts = goodsList.value;
			for(let i=0;i<shoppingCarts.length;i++){
				if(!shoppingCarts[i].checked){
					flag = false;
					break;
				}
			}
			if(flag){
				checkAllStauts.value = true;
			}else{
				checkAllStauts.value = false;
			}
			// 计算金额
			fnDealMoney();
		}, 100);
	}
	// 全选所有商品
	function checkAllGoods() {
		let shoppingCarts = goodsList.value;
		if (checkAllStauts.value) {
			for(let i=0;i<shoppingCarts.length;i++){
				shoppingCarts[i].checked = false;
			}
		} else {
			for(let i=0;i<shoppingCarts.length;i++){
				if(shoppingCarts[i].isFall != 1){
					shoppingCarts[i].checked = true;
				}
			}
		}
		goodsList.value = shoppingCarts;
		fnDealMoney()
	}
	function fnNumBlur(blurObj){
		if(blurObj.value == null || blurObj.value == ''){
			blurObj.value = 1;
		}
		setTimeout(() => {
			let goodsOlds = goodsList.value.filter(e=>e.singleProdId===blurObj.name)
			if(goodsOlds == null || goodsOlds.length === 0){
				return
			}
			goodsOlds[0].num = blurObj.value
			// 处理购物车中的对应商品数量
			if(goodsOlds[0].num > goodsOlds[0].redisVirtualNum){
				ctx.$u.toast(goodsOlds[0].prodName+'('+goodsOlds[0].specDispStr+')库存不足！');
				goodsOlds[0].num = goodsOlds[0].redisVirtualNum;
				fnNumChange(goodsOlds[0]);
				return;
			}
			let goods = goodsList.value.filter(e=>e.singleProdId===goodsOlds[0].singleProdId)
			// 获取购物车商品数据
			const savedCart = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
			if(savedCart && savedCart != undefined && savedCart != null){
				let savedCarts = JSON.parse(savedCart);
				let savedCartsNew = [];
				for(let i=0;i<savedCarts.length;i++){
					if(savedCarts[i].singleProdId === goods[0].singleProdId){
						savedCarts[i].num = goods[0].num;
					}
					savedCartsNew.push(savedCarts[i])
				}
				uni.removeStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId)
				uni.setStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(savedCartsNew));
			} 
			// 计算金额
			fnDealMoney();
		}, 100);
	}
	// 数量变更
	function fnNumChange(goodsOld){
		console.log("-------------------fnNumChange",goodsOld)
		setTimeout(() => {
			// 处理购物车中的对应商品数量
			if(goodsOld.num > goodsOld.redisVirtualNum){
				ctx.$u.toast(goodsOld.prodName+'('+goodsOld.specDispStr+')库存不足！');
				goodsOld.num = goodsOld.redisVirtualNum;
				fnNumChange(goodsOld);
				return;
			}
			let goods = goodsList.value.filter(e=>e.singleProdId===goodsOld.singleProdId)
			// 获取购物车商品数据
			const savedCart = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
			if(savedCart && savedCart != undefined && savedCart != null){
				let savedCarts = JSON.parse(savedCart);
				let savedCartsNew = [];
				for(let i=0;i<savedCarts.length;i++){
					if(savedCarts[i].singleProdId === goods[0].singleProdId){
						savedCarts[i].num = goods[0].num;
					}
					savedCartsNew.push(savedCarts[i])
				}
				uni.removeStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId)
				uni.setStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(savedCartsNew));
			} 
			// 计算金额
			fnDealMoney();
		}, 100);
	}
	// 计算合计金额
	function fnDealMoney(){
		let allMoney = 0;
		let shoppingCarts = goodsList.value;
		for(let i=0;i<shoppingCarts.length;i++){
			if(shoppingCarts[i].checked){
				allMoney += util.fnMul(shoppingCarts[i].num,shoppingCarts[i].price)
			}
		}
		totalPrice.value = allMoney;
	}
	// 清除失效商品
	function fnClearStopProd(){
		// 获取购物车商品数据
		const savedCart = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
		if(savedCart && savedCart != undefined && savedCart != null){
			let savedCarts = JSON.parse(savedCart);
			let savedCartsNew = [];
			for(let i=0;i<savedCarts.length;i++){
				let filterGoods = goodsList.value.filter(e=>e.singleProdId===savedCarts[i].singleProdId);
				if(filterGoods != null && filterGoods.length > 0){
					if(filterGoods[0].isFall != 1){
						savedCartsNew.push(savedCarts[i]);
					}
				}
			}
			uni.removeStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId)
			uni.setStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(savedCartsNew));
			const savedCart1 = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
			if(savedCart1 && savedCart1 != undefined && savedCart1 != null){
				goodsList.value = JSON.parse(savedCart1);
			}
			// 计算金额
			fnDealMoney();
		} 
		isShowClearStopProd.value = 0;
		// 处理购物车数量显示
		fnDealCartNum();
	}
	// 计算购物车数量
	function fnDealCartNum(){
		emit('fnDealCartNum')
	}
	// 删除购物车商品
	function fnDeleteShoppingCart(){
		console.log("-----------goodsList.value",goodsList.value)
		let index = 0;
		let savedCartsNew = [];
		for(let i=0;i<goodsList.value.length;i++){
			if(!goodsList.value[i].checked){
				savedCartsNew.push(goodsList.value[i])
			}else{
				index+=1
			}
		}
		if(index == 0){
			ctx.$u.toast("请至少选择一个商品");
			return
		}
		uni.removeStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId)
		uni.setStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(savedCartsNew));
		const savedCart1 = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
		if(savedCart1 && savedCart1 != undefined && savedCart1 != null){
			goodsList.value = JSON.parse(savedCart1);
		}
		// 计算金额
		fnDealMoney();
		// 处理购物车数量显示
		fnDealCartNum();
	}
	// 去结算
	function goPayResult(){
		let savedCartsNew = [];
		for(let i=0;i<goodsList.value.length;i++){
			if(goodsList.value[i].checked){
				savedCartsNew.push(goodsList.value[i])
			}
		}
		if(savedCartsNew.length == 0){
			ctx.$u.toast("请至少选择一个商品");
			return
		}
		// 判断是否冻结
		checkoutUserInfo(savedCartsNew);
	}
	// 判断是否冻结
	function checkoutUserInfo(savedCartsNew){
		var param = {};
		param.membId = ctx.vuex_membid;
		checkOutMembInfoApi(JSON.stringify(param)).then(res => {
		    if(res.retCode == 1){
				// 校验限购
				checkOutProd(savedCartsNew);
			}else{
				ctx.$u.toast(res.retMsg);
			}
		})
	}
	// 校验限购
	function checkOutProd(savedCartsNew){
		if(data.isDontSale==1){
			ctx.$u.toast("暂未开放购买");
		}
		// 跳转到结算页
		let buyProds = getBuyProds(savedCartsNew)
		console.log("----------------跳转到结算页",JSON.stringify(buyProds))
		uni.navigateTo({
		  url: "../orderSettlement/orderSettlement?savedCarts="+JSON.stringify(buyProds),
		});
	}
	// 获取结算参数
	function getBuyProds(savedCartsNew){
		let orderProductDetailBos = [];
		for(let i=0;i<savedCartsNew.length;i++){
			let orderProductDetailBo = {
			    singleProdId: savedCartsNew[i].singleProdId,
			    buyNum: savedCartsNew[i].num,
			    prodName: savedCartsNew[i].prodName,
			    prodType: savedCartsNew[i].prodType,
			    detailType: savedCartsNew[i].detailType==null||savedCartsNew[i].detailType=='' ? 1 : savedCartsNew[i].detailType,
			    isNew: 1,
			    isGift: 0,//默认非赠品
			    isFullfil: 0,//默认非满赠 
			};
			orderProductDetailBos.push(orderProductDetailBo);
		}
		return orderProductDetailBos;
	}
	onShow(() => {
		console.log("onShow 我是cart")
	})
	
	/**
	 * 模拟onShow方法
	 */
	function onHandleShow() {
	   console.log("onHandleShow 我是cart")
	}
	
	// 将 onHandleShow 暴露给父组件
	defineExpose({ onHandleShow });
</script>

<style lang="scss" scoped>
.page {
	background: #fafafa;
	padding: 24rpx;
}
.u-icon {
	display: flex !important;
}

.cart-list {
	margin-top: 100rpx;
	margin-bottom: 100rpx;
	.item {
		display: flex;
		align-items: center;
		background-color:  #ffffff;
		padding: 30rpx 24rpx 30rpx 24rpx;
		border-bottom: 1rpx solid #efefef;

		.left {
			display: flex;
			align-items: center;
			width: 46rpx;
		}
		.right {
			width: calc(100% - 46rpx);
			display: flex;
			align-items: center;
			.img {
				width: 160rpx;
				height: 160rpx;
				margin-right: 20rpx;
				image {
					width: 100%;
					height: 100%;
				}
			}
			.info {
				// width: 418rpx;
				width: 500rpx;
				.title {
					font-size: 28rpx;
					font-family: PingFang-SC-Regular, PingFang-SC;
					font-weight: 400;
					color: #171717;
					padding-bottom: 16rpx;
				}
				.sku {
					font-size: 22rpx;
					font-family: PingFang-SC-Regular, PingFang-SC;
					font-weight: 400;
					background: #fafafa;
					border-radius: 2px;
					color: #696969;
					padding: 4rpx 16rpx;
				}
				.operate {
					padding-top: 30rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.price {
						text:nth-child(1) {
							font-size: 24rpx;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: 500;
							color: #fd4558;
							width: 100rpx;
						}
						text:nth-child(2) {
							font-size: 36rpx;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #fd4558;
						}
						text:nth-child(3) {
							font-size: 28rpx;
							color: #cccccc;
							text-decoration-line: line-through;
							margin-left: 10rpx;
						}
					}
					.num {
						position: absolute;
						right: 24rpx;
					}
				}
			}
		}
	}
}

.recommend {
	padding-top: 32rpx;
	padding-bottom: 120rpx;
	.title {
		text-align: center;
		font-size: 36rpx;
		font-weight: 500;
		color:  #171717;
		padding-bottom: 16rpx;
		height: auto !important;
	}
	.list {
	}
}

.btn {
	position: fixed;
	bottom: calc(100upx + env(safe-area-inset-bottom) / 2);
	left: 0;
	width: 100%;
	background-color:  #ffffff;
	min-height: 100rpx;
	.check {
		padding-left: 30rpx;
		display: flex;
		align-items: center;
		text {
			font-size: 28rpx;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #171717;
		}
	}
	.right {
		display: flex;
		align-items: center;
		.price {
			margin-right: 40rpx;
			view:nth-child(1) {
				font-size: 28rpx;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #171717;
				width: 90rpx;
			}
			view:nth-child(2) {
				font-size: 24rpx;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #fd4558;
			}
			view:nth-child(3) {
				font-size: 36rpx;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #fd4558;
			}
		}
		button {
			height: 100%;
			line-height: 70rpx;
			border-radius: 50rpx !important;
			margin-right: 30rpx;
		}
	}
}
.shop_list_top{
	position: fixed;
	    width: 100%;
	    z-index: 99;
  height: 100rpx;
  line-height: 63rpx;
  background-color: #f4f4f4;
  color: #989898;
  /* border-radius: 50rpx 50rpx 0 0; */
  text-align: left;
  padding: 19rpx 30rpx;
  font-size: 28rpx;
  button {
  	height: 100%;
  	line-height: 70rpx;
  	border-radius: 50rpx !important;
  	margin-right: 0rpx;
	width: 120rpx;
  }
}
// .shop_list_top view{
//   float: right;
//   color: #302728;
//   line-height: 50rpx;
//   font-size: 24rpx;
//   border: 1px solid #a5a29b;
//   border-radius: 40rpx;
//   padding-left: 30rpx;
//   padding-right: 30rpx;
// }
</style>